import { useEffect, useState } from "react";

const useMouseLeave = (conditions: boolean[] = [true]) => {
  const [isMouseOut, setIsMouseOut] = useState(false);

  useEffect(() => {
    if (conditions.every((condition) => condition)) {
      const handleMouseLeave = () => {
        setIsMouseOut(true);
      };

      document.addEventListener("mouseout", function (event) {
        if (
          event.clientY <= 0 ||
          event.clientX <= 0 ||
          event.clientX >= window.innerWidth ||
          event.clientY >= window.innerHeight
        ) {
          handleMouseLeave();
        }
      });

      return () => {
        document.removeEventListener("mouseout", handleMouseLeave);
      };
    }
  }, [conditions]);

  return isMouseOut;
};

export default useMouseLeave;